<div class="g-suite-login--main-wrapper">
  {#if $store.isLoading || $store.isRedirecting}
    <div class="g-suite-login--loading-spinner"></div>
  {:else if $store.noConnectedAccount}
    <LoginError errorMessage={$store.i18n.NoGoogleAccountConnected} GoToItslButton=true/> 
  {:else if $store.multipleAccounts}
    <LoginError errorMessage={$store.i18n.MultipleAccountsError} />
  {:else if $store.ssoDisabled}
    <LoginError errorMessage={$store.i18n.SettingDisabledError} />
  {:else if $store.hasErrors}
    <LoginError errorMessage={$store.i18n.GlobalError} ReloadPage=true/>
  {:else if !$store.isUserSignedIn && $store.isInitialised}
    <span class="sign-in-text">{$store.i18n.SignInToConsentChrome}</span>
    <SignInButton />
  {/if}    
</div>

<script>
  import LoginError from './LoginError.svelte';
  import SignInButton from './SignInButton.svelte';

  import { store } from '../store';
</script>